// Constantes de la landing pública. Sin llamadas a API, todo hardcodeado/de ejemplo.

export const CONTACT_EMAIL = 'info@capabilia.org';
export const CONTACT_SUBJECT = 'Consulta Persistencia 360';
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(CONTACT_SUBJECT)}`;

// Mismo verde marca que usa el panel del login (LoginPage.jsx)
export const CAPABILIA_GREEN = '#00A878';
export const CAPABILIA_GREEN_DARK = '#007A55';

// Degradé esmeralda del hero (pedido explícito del CTO)
export const HERO_GRADIENT = 'linear-gradient(135deg, #065F46 0%, #047857 50%, #00A878 100%)';

export const NAV_LINKS = [
  { label: 'Qué hace', href: '#que-hace' },
  { label: 'Cómo funciona', href: '#como-funciona' },
  { label: 'Módulos', href: '#modulos' },
  { label: 'Integraciones', href: '#integraciones' },
];

// Datos de ejemplo del semáforo - ILUSTRATIVOS, no reales, no vienen de la API
export const SEMAFORO_EJEMPLO = [
  { color: 'green', count: 412 },
  { color: 'blue', count: 618 },
  { color: 'yellow', count: 305 },
  { color: 'orange', count: 189 },
  { color: 'red', count: 97 },
  { color: 'dark_gray', count: 142 },
  { color: 'black', count: 88 },
];
